export default "__VITE_ASSET__Dl5L77h___"